function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M53 31L0 62V0z",
  fill: "#fff"
});

function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 62,
    viewBox: "0 0 53 62"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MyIgaGVpZ2h0PSI2MiIgdmlld0JveD0iMCAwIDUzIDYyIj48cGF0aCBkPSJNMzEsMCw2Miw1M0gwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTMpIHJvdGF0ZSg5MCkiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
export { SvgTriangle as ReactComponent };